// ArticlesPage.js — /articles index.

import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import SEO from "./components/SEO";
import { PageHeader, ProsePage } from "./components/Prose";
import { BRAND } from "./theme";
import { ARTICLES, formatArticleDate } from "./articles";

export default function ArticlesPage() {
  return (
    <ProsePage>
      <SEO
        title="Premier League scoreline stories and analysis"
        description="Stories from the Premier League scorigami grid: the rarest scorelines in league history, where the next scorigami will come from, and how the grid works."
        path="/articles"
      />
      <PageHeader
        eyebrow="Articles"
        title="Stories from the Premier League scorigami grid"
        lede="The matches behind the Premier League's rarest results, what the grid tells us about home advantage, and where the next never-seen-before scoreline is likely to come from."
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {ARTICLES.map((a) => (
          <Box
            key={a.slug}
            component={RouterLink}
            to={`/articles/${a.slug}`}
            sx={{
              display: "block",
              textDecoration: "none",
              p: { xs: 2.25, sm: 3 },
              borderRadius: 3,
              background: "rgba(20,20,26,0.72)",
              border: "1px solid rgba(255,255,255,0.08)",
              transition: "border-color 160ms ease, transform 160ms ease",
              "&:hover": { borderColor: BRAND.cyan, transform: "translateY(-2px)" },
            }}
          >
            <Typography sx={{ color: BRAND.textSecondary, fontSize: 12.5, mb: 0.75 }}>
              {formatArticleDate(a.date)} · {a.minutes} min read
            </Typography>
            <Typography component="h2" sx={{ color: "#fff", fontSize: { xs: 19, sm: 22 }, fontWeight: 800, lineHeight: 1.25, mb: 1 }}>
              {a.title}
            </Typography>
            <Typography sx={{ color: "#c9ccd6", fontSize: 15, lineHeight: 1.6 }}>{a.description}</Typography>
          </Box>
        ))}
      </Box>
    </ProsePage>
  );
}
